export const SUPPORTED_TUTORIAL_LANGUAGES = ["en", "fa"];

export function normalizeTutorialLanguage(value, fallback = "en") {
  const normalized = String(value || "").trim().toLowerCase();
  return SUPPORTED_TUTORIAL_LANGUAGES.includes(normalized) ? normalized : fallback;
}

export const configuredLanguage = normalizeTutorialLanguage(
  process.env.REACT_APP_DEFAULT_LANGUAGE,
);

export function appendLanguage(url, language = configuredLanguage, baseUrl = window.location.href) {
  if (!url) return url;
  const parsed = new URL(url, baseUrl);
  parsed.searchParams.set("lang", normalizeTutorialLanguage(language));
  return parsed.toString();
}
